import idb from "./idb"
import moment from "./moment"
import { getDeletedFoods, getFoods } from "services"
import refactorFoods from "./refactorFoods"
import delay from "./delay"
import registerLastOnlineTime from "./registerLastOnlineTime"
import {
  store,
  addFoods,
  updateFoods,
  deleteFoods,
  addFoodsToCategoryGroup,
  removeFoodsFromCategoryGroup,
  updateFoodsInCategoryGroup
} from "@redux"

let stopFetching = false

const limit = 50

const localStorageItemName =
  "isFetchedBefore-v1"

const getLastUpdatedTime = (branchId) => {
  const lastOnlineTimes =
    JSON.parse(
      localStorage.getItem("lastOnlineTimes") || "{}"
    )

  const lastOnlineTime =
    Number(lastOnlineTimes[branchId])

  const initialUpdatedAt =
    !!lastOnlineTime
      ? moment(lastOnlineTime).toISOString()
      : moment().toISOString()

  return initialUpdatedAt
}

const fetchLatestFoodsFromServer = async (branchId, skip, updatedAt) => {
  try {
    const response =
      await getFoods({
        skip,
        limit,
        branchId,
        updatedAt,
        isAvailable: true
      })

    const refactoredFoods =
      refactorFoods(response, branchId)

    store.dispatch(
      updateFoodsInCategoryGroup(refactoredFoods)
    )

    store.dispatch(
      updateFoods(refactoredFoods)
    )

    if (response.length !== limit) {
      registerLastOnlineTime()

      return
    }

    await delay(2000)

    if (stopFetching) return

    fetchLatestFoodsFromServer(
      branchId,
      skip + limit,
      updatedAt
    )
  } catch (err) {
    console.log(err)

    await delay(5000)

    if (stopFetching) return

    fetchLatestFoodsFromServer(
      branchId,
      skip,
      updatedAt
    )
  }
}

const fetchDeletedFoodsFromServer = async (skip, updatedAt) => {
  try {
    const response =
      await getDeletedFoods({
        skip,
        limit,
        updatedAt
      })

    store.dispatch(
      deleteFoods(response)
    )

    store.dispatch(
      removeFoodsFromCategoryGroup(response)
    )

    if (response.length !== limit) {
      return registerLastOnlineTime()
    }

    await delay(2000)

    if (stopFetching) return

    fetchDeletedFoodsFromServer(
      skip + limit,
      updatedAt
    )
  } catch (err) {
    console.log(err)

    await delay(5000)

    if (stopFetching) return

    fetchDeletedFoodsFromServer(
      skip,
      updatedAt
    )
  }
}

const initialFetchCompleted = (branchId) => {
  const json =
    localStorage.getItem(localStorageItemName)

  const isFetchedBefore = JSON.parse(json || "{}")

  isFetchedBefore[branchId] = true

  localStorage.setItem(
    localStorageItemName,
    JSON.stringify(isFetchedBefore)
  )
}

const initialFetchFromServer = async (branchId, skip) => {
  try {
    const response =
      await getFoods({
        skip,
        limit,
        branchId,
        isAvailable: true
      })

    const refactoredFoods =
      refactorFoods(response, branchId)

    store.dispatch(
      addFoods(refactoredFoods)
    )

    store.dispatch(
      addFoodsToCategoryGroup(refactoredFoods)
    )

    await delay(2000)

    if (stopFetching) return

    if (response.length !== limit) {
      registerLastOnlineTime()

      initialFetchCompleted(branchId)

      return
    }

    initialFetchFromServer(branchId, skip + limit)
  } catch (err) {
    await delay(2000)

    if (stopFetching) return

    initialFetchFromServer(branchId, skip)
  }
}

const start = async (branchId) => {
  const foodsInDatabase =
    await idb.getAllItemsFromDatabase(branchId, "foods")

  store.dispatch(
    addFoods(foodsInDatabase.reverse())
  )

  store.dispatch(
    addFoodsToCategoryGroup(foodsInDatabase)
  )

  const isFetchedBefore =
    JSON.parse(
      localStorage.getItem(localStorageItemName) || "{}"
    )

  const haveFetchedItemsBefore =
    !!isFetchedBefore[branchId]

  stopFetching = false

  if (haveFetchedItemsBefore) {
    const initialSkip = 0

    const initialUpdatedAt =
      getLastUpdatedTime(branchId)

    fetchLatestFoodsFromServer(
      branchId,
      initialSkip,
      initialUpdatedAt
    )

    fetchDeletedFoodsFromServer(
      initialSkip,
      initialUpdatedAt
    )

    return
  }

  const initialSkip = 0

  initialFetchFromServer(branchId, initialSkip)
}

const stop = () => stopFetching = true

const fetchFoodsInbackground = { start, stop }

export default fetchFoodsInbackground